import { useEffect, useState } from "react";
import { useRouteError } from "react-router-dom";
import { useSignOut } from "src/infrastructure/auth";
import { PageLoader } from "src/components/PageLoader/PageLoader";
import { StatusPage } from "src/components/StatusPage/StatusPage";
import { GoHomeButton, ReloadButton } from "src/components/StatusPage/StatusPageActions";
import { claimReload, isDynamicImportError } from "src/utils/dynamicImportReload";

/**
 * Shown when any route throws. A failed lazy-chunk load reloads automatically
 * (capped by claimReload) before this appears.
 * Reference: twosion-ui src/pages/AppErrorPage/AppErrorPage.page.tsx.
 */
export function AppErrorPage() {
  const error = useRouteError();
  const signOut = useSignOut();
  const [reloading] = useState(() => isDynamicImportError(error) && claimReload());

  useEffect(() => {
    console.error("[router] application error:", error);
    if (reloading) window.location.reload();
  }, [error, reloading]);

  if (reloading) return <PageLoader label="Reloading" />;

  return (
    <StatusPage
      title="Application Error"
      body="Something went wrong while loading this page. Reload to try again, or go back to the home page. If it keeps happening, please contact your administrator."
      actions={
        <>
          <ReloadButton />
          <GoHomeButton emphasis="secondary" />
        </>
      }
      onSignOut={signOut}
    />
  );
}
